<app-filter-header title="Filtrar motius anul·lació" i18n-title  (apply)="this.apply()" (reset)="this.reset()" (dismiss)="this.dismiss()"></app-filter-header>
<div class="modal-body">
  <div class="row">
    <!-- <app-filter-text-edit autofocus class="col-sm-3" i18n-label label="Id" [(value)]="filter.id"></app-filter-text-edit> -->
    <app-filter-text-edit id="motius-anulacio-filter-descripcio" class="col-sm-9" i18n-label label="Descripció" [(value)]="filter.descripcio"></app-filter-text-edit>
  </div>
</div>
